@import '../../../../../../constants/spacing.module.less';
@import '../../../../../../constants/screen-width-breakpoints.module.less';

.empty-state-container {
  align-items: center;
  justify-content: flex-start;
  min-height: 60%;
  padding: @space-24 @space-48;
  text-align: center;
  max-width: 800px;
  margin: @space-0 auto;
}

.empty-state-icon {
  margin-bottom: @space-48;
  opacity: 0.6;
  height: 300px;
}

.empty-state-content {
  margin-bottom: @space-24;
}

.empty-state-header {
  margin-bottom: @space-24;
  color: var(--grey-700);
}

.empty-state-description {
  margin-bottom: @space-24;
  color: var(--grey-600);
}

.actions-row {
  gap: @space-24;
  align-items: center;
}

.learn-more-link-container {
  gap: @space-8;
  align-items: center;
  margin-left: @space-24;
}

.learn-more-link {
  color: var(--blue-500);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.external-link-icon {
  width: 14px;
  height: 14px;
  color: var(--blue-500);
}

@media @mobile {
  .empty-state-container {
    padding: @space-32;
    min-height: 50%;
  }

  .empty-state-icon {
    width: 80px;
    height: 80px;
    margin-bottom: @space-32;
  }
}
